exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cu-form-item .ant-col label {\n  padding-right: 15px !important;\n  color: #8c8c8c;\n}\n.cu-input-loading-style {\n  align-items: center;\n  justify-content: center;\n  display: flex;\n}\n.cu-loading-spin {\n  height: 180px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}", ""]);

// exports
